import React from 'react';
import { CardLogoImg } from './styled';
import { useAppSelector } from '../../hooks/useAppSelector';
import { CARD_ANNOUNCEMENT_ID, CardTypeDisplayedNames } from '../../constants/PaymentTypes';
import { configSelector } from '../../redux/ConfigState/ConfigState.selectors';
var CardLogo = function CardLogo(props) {
  var cardType = props.cardType,
    valid = props.valid,
    dataTest = props.dataTest,
    id = props.id,
    isMopContainer = props.isMopContainer;
  var config = useAppSelector(configSelector);
  var appConstants = config.appConstants;
  var _ref = appConstants,
    cdnUrl = _ref.cdnUrl;
  function getAriaLabel(cardType) {
    var mappedName = CardTypeDisplayedNames[cardType];
    var displayName = mappedName ? mappedName : 'Unknown';
    return "".concat(displayName, " logo");
  }
  return /*#__PURE__*/React.createElement(CardLogoImg, {
    id: id,
    "data-test": dataTest,
    cardType: cardType,
    valid: valid,
    role: 'img',
    cdnUrl: cdnUrl,
    "aria-label": getAriaLabel(cardType),
    "aria-describedby": valid ? CARD_ANNOUNCEMENT_ID : undefined,
    isMopContainer: isMopContainer
  }, "\xA0");
};
export default /*#__PURE__*/React.memo(CardLogo);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/CardLogo/index.js
// module id = 495
// module chunks = 11